import type { User as OidcUser } from "oidc-client-ts";
import type { ReactNode } from "react";
import type { AuthParamsSnapshot } from "./authParams";

export interface User {
  id: string;
  username: string;
  name: string;
  email: string;
  avatar: string;
}

export interface AuthContextType {
  user: User | null;
  oidcUser: OidcUser | null;
  isAuthenticated: boolean;
  loading: boolean;
  login: (user: User, token: string, refreshToken?: string) => void;
  logout: () => void;
  signinTpass: () => void;
  signOutRedirect: () => void;
  handleSignInRequest: (params?: AuthParamsSnapshot) => Promise<boolean>;
  signinRedirect: () => void;
  saveRedirectPath: () => void;
  getRedirectPath: () => string;
}

export interface AuthProviderProps {
  children: ReactNode;
  cognitoAuthConfig: {
    authority: string;
    client_id: string;
    redirect_uri: string;
    response_type: string;
    scope: string;
  };
}

export const defaultAuthContext: AuthContextType = {
  user: null,
  oidcUser: null,
  isAuthenticated: false,
  loading: true,
  login: () => {},
  logout: () => {},
  signinTpass: () => {},
  signOutRedirect: () => {},
  handleSignInRequest: async () => false,
  signinRedirect: () => {},
  saveRedirectPath: () => {},
  getRedirectPath: () => "",
};
